import { render } from "./ServiceLnb.vue?vue&type=template&id=6aef1a15"
import script from "./ServiceLnb.vue?vue&type=script&lang=js"
export * from "./ServiceLnb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__